import React, { useState } from 'react';
import styles from './index.module.less';
import couponsStyles from '@app/account/coupons/index.module.less';
import cn from 'classnames';
import { ICoupon } from 'mod/coupon/interface';
import Iconfont from '@base/lib/Iconfont';
import { Drawer } from '@base/lib/Drawer';
import CouponList from '@base/account/coupons/CouponList';
import { useTrans } from 'base/utils/i18n';
import { isPhone } from 'base/utils/client';

type CartCouponProps = {
    className?: string;
    coupons: ICoupon[];
};

const ProductCoupons: React.FC<CartCouponProps> = props => {
    const { coupons, className } = props;
    const [visible, setVisible] = useState<boolean>(false);
    const { t } = useTrans();

    return coupons.length === 0 ? null : (
        <div className={className}>
            <div className={styles.trigger} onClick={() => setVisible(true)}>
                <span className={styles.title}>{t('web_product_coupons_title')}</span>
                <span className={styles.price}>{coupons[0].expect}</span>
            </div>
            {/* coupons 抽屉 */}
            <Drawer
                title={t('web_coupons_drawer_title')}
                open={visible}
                onClose={() => setVisible(false)}
                footer={false}
                className={styles.drawer}
                {...(isPhone ? {
                    placement: 'bottom',
                    height: 'auto',
                } : {
                    placement: 'right',
                    width: 440,
                    closePlacement: 'left',
                    closeIconType: 'arrow'
                })}
                body={
                    <div className={styles['drawer-content']}>
                        <div className={styles['use-tip']}>
                            <Iconfont className="icon-info"/> {t('web_coupons_use_tip')}
                        </div>
                        <h3 className={styles.available}>{t('web_coupons_available_title')}</h3>
                        <CouponList
                            list={coupons}
                            className={cn(couponsStyles.list, couponsStyles['list-whole-line'])}
                        />
                    </div>
                }
            />
        </div>
    )
};

export default ProductCoupons;